// Reason for separating is that ConfirmationDialog.vue value state is shared globally
import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let ConfirmationDialog = class ConfirmationDialog extends Mixins(ViewportSizeMixin) {
    /**
     * event handler if component is confirmed
     */
    confirmed() {
        this.$emit('confirm');
    }
    onCancel() {
        this.$emit('input', false);
        this.$emit('cancel');
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], ConfirmationDialog.prototype, "value", void 0);
__decorate([
    Prop({ type: String, default: 'Remove?' })
], ConfirmationDialog.prototype, "message", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ConfirmationDialog.prototype, "requestOnProcess", void 0);
__decorate([
    Prop({ type: String, default: 'Confirm Delete' })
], ConfirmationDialog.prototype, "header", void 0);
__decorate([
    Prop({ type: String, default: 'Delete' })
], ConfirmationDialog.prototype, "confirmLabel", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ConfirmationDialog.prototype, "remove", void 0);
ConfirmationDialog = __decorate([
    Component({
        components: {
            ActionButton,
        },
    })
], ConfirmationDialog);
export default ConfirmationDialog;
